// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".title[data-v-3e19e037] {\n  font-size: 14px;\n  font-weight: bold;\n  color: #f5222d;\n  margin-bottom: 10px;\n}\n.desc[data-v-3e19e037] {\n  font-size: 14px;\n  color: #595959;\n  margin-bottom: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
